const getAdminReduxTypes = pageName => ({
  FETCH_ENTITIES: `${pageName}/FETCH_ENTITIES`,
  FETCH_ENTITIES_SUCCESS: `${pageName}/FETCH_ENTITIES_SUCCESS`,
  FETCH_ENTITIES_FAILURE: `${pageName}/FETCH_ENTITIES_FAILURE`,
  SAVE_ENTITY: `${pageName}/SAVE_ENTITY`,
  SAVE_ENTITY_SUCCESS: `${pageName}/SAVE_ENTITY_SUCCESS`,
  SAVE_ENTITY_FAILURE: `${pageName}/SAVE_ENTITY_FAILURE`,
  REMOVE_ENTITY: `${pageName}/REMOVE_ENTITY`,
  REMOVE_ENTITY_SUCCESS: `${pageName}/REMOVE_ENTITY_SUCCESS`,
  REMOVE_ENTITY_FAILURE: `${pageName}/REMOVE_ENTITY_FAILURE`,
  UPLOAD_ENTITIES: `${pageName}/UPLOAD_ENTITIES`,
  UPLOAD_ENTITIES_SUCCESS: `${pageName}/UPLOAD_ENTITIES_SUCCESS`,
  UPLOAD_ENTITIES_FAILURE: `${pageName}/UPLOAD_ENTITIES_FAILURE`,
  IMPORT_ENTITIES: `${pageName}/IMPORT_ENTITIES`,
  IMPORT_ENTITIES_SUCCESS: `${pageName}/IMPORT_ENTITIES_SUCCESS`,
  IMPORT_ENTITIES_FAILURE: `${pageName}/IMPORT_ENTITIES_FAILURE`,
  CLEAR_UPLOADED_ENTITIES: `${pageName}/CLEAR_UPLOADED_ENTITIES`,
});

export default getAdminReduxTypes;
